import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.23 8.255a.75.75 0 0 1 .78.72l.345 9a.75.75 0 0 1-1.499.058l-.346-9a.75.75 0 0 1 .72-.778m5.54 0a.75.75 0 0 1 .72.778l-.346 9a.75.75 0 0 1-1.5-.057l.347-9a.75.75 0 0 1 .778-.72"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.5 4.71v-.227c0-1.565-1.213-2.9-2.815-2.951a53 53 0 0 0-3.37 0C8.713 1.582 7.5 2.918 7.5 4.482v.228a49 49 0 0 0-3.878.512.75.75 0 1 0 .256 1.478l.209-.036 1.005 13.07a3 3 0 0 0 2.992 2.77h7.832a3 3 0 0 0 2.992-2.77l1.005-13.07.209.036a.75.75 0 0 0 .256-1.478A49 49 0 0 0 16.5 4.71M12 3.005q-.821 0-1.637.026C9.61 3.055 9 3.689 9 4.483v.112a50 50 0 0 1 6 0v-.112c0-.794-.609-1.428-1.363-1.452A51 51 0 0 0 12 3.005m6.426 3.433A47 47 0 0 0 12 6.005a48 48 0 0 0-6.426.433L6.588 19.62a1.5 1.5 0 0 0 1.496 1.385h7.832a1.5 1.5 0 0 0 1.496-1.385z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }